/* eslint-disable array-callback-return */
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import './styles.scss'
import axios from 'axios'
import { Loader } from 'react-bootstrap-typeahead'
import LoadingSpinner from '../../LoadingSpinner'
import BarChartt from './BarChart2'
import InfiniteScroll from 'react-infinite-scroll-component'
import HorizontalBar from './HorizontalBar'
import Values from './Values'
import { v4 as uuidv4 } from 'uuid'
// import { liftingFileNameRef } from '../AddFile'

interface IPROPS {
  totalRecors: any
  setColumns: any
}

const TableHeader: React.FC<IPROPS> = ({ totalRecors, setColumns }) => {
  const [tableData, setTableData] = useState<any>()
  const [page, setPage] = useState<number>(1)
  const count = 20
  const [loading, setLoading] = useState<boolean>(false)
  const [chartData, setChartData] = useState<any>([])
  const [category, setCategory] = useState<any>([])
  const [rowValues, setRowValues] = useState<any>(null)
  const [statistics, setStatistics] = useState<any>(null)
  const [uniqueValue, setUniqueValue] = useState<any>(null)
  const [getTableRow, setGetTableRow] = useState<any>(null)
  const [apiCalled, setApiCalled] = useState(false)
  const [dataTypes, setDataTypes] = useState([])
  const [dropDown, setDropDown] = useState(null)
  const [dropDownVisible, setDropDownVisible] = useState(false)
  const [selectedValue, setSelectedValue] = useState(0)
  const [column, setColumn] = useState(null)
  const [graphLoading, setGraphLoading] = useState(false)

  const selectArry = ['Text', 'Number (Integer)', 'Number', 'ID', 'Date', 'Category', 'Disabled']

  useEffect(() => {
    fetchData()
    // const timer = setTimeout(() => {
    //   fetchData()  t
    // }, 6000)
    // return () => clearTimeout(timer)
  }, [])

  const fetchData = async () => {
    try {
      setLoading(true)

      const response = await axios.get(
        `${process.env.REACT_APP_CSV_ANALYTICS_URL}/csv-analytics/get_data/${localStorage.getItem(
          'uploadedFileName'
        )}/${page}/${count}`,
        { withCredentials: true }
      )

      console.log(response, 'responsee get_data')

      const dataFromApi = response?.data
      // Ensure that dataFromApi is an array
      const validData = Array.isArray(dataFromApi) ? dataFromApi : []

      setTableData((prevData: any) => [...(Array.isArray(prevData) ? prevData : []), ...validData])

      // setGetTableRow(response?.data?.total_rows)
      setPage((prevPage) => prevPage + 1)
      setLoading(false)
    } catch (error) {
      console.error('Error', error)
      setLoading(false)
    }
  }

  useEffect(() => {
    totalRecors(getTableRow)
  }, [category, getTableRow, totalRecors])

  const chartApi = useCallback(async () => {
    setLoading(true)
    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_CSV_ANALYTICS_URL
        }/csv-analytics/top10?filename=${localStorage.getItem('uploadedFileName')}`,
        { withCredentials: true }
      )
      console.log(response, 'response top10')
      if (response.status === 200) {
        setChartData(response?.data)
        setLoading(false)
        setApiCalled(false)
      } else {
        setApiCalled(false)
      }
    } catch (error) {
      console.log(error, 'error')
      setLoading(false)
    }
  }, [])

  console.log(chartData, 'chartDsas')

  useEffect(() => {
    if (!apiCalled) {
      chartApi()
    }
  }, [apiCalled])

  // useEffect(() => {
  //   const chartColumns = chartData.map((el: any) => el.column)
  //   setColumn(chartColumns)
  // }, [chartData])

  useEffect(() => {
    analyzeAPI()
  }, [])

  const sanitizeResponseData = (data: any) => {
    // Convert NaN values to null in the response string
    return data.replace(/NaN/g, 'null')
  }

  const analyzeAPI = useCallback(async () => {
    setLoading(true)
    setGraphLoading(true)
    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_CSV_ANALYTICS_URL
        }/csv-analytics/analyze?filename=${localStorage.getItem('uploadedFileName')}`,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'json', // Ensure response is treated as JSON
          maxContentLength: 50 * 1024 * 1024, // 50MB limit for response content length
          maxBodyLength: 50 * 1024 * 1024 // 50MB limit for request/response body
        }
      )

      // Check if response data is a string and sanitize it if necessary
      let responseData = response?.data
      console.log(response, 'analyze')

      if (typeof responseData === 'string') {
        try {
          responseData = sanitizeResponseData(responseData) // Sanitize the response to handle NaN values
          responseData = JSON.parse(responseData) // Parse the sanitized string into JSON
        } catch (e) {
          console.error('Failed to parse response data:', e)
        }
      }

      console.log(responseData, 'analyze')

      // Update the state with the parsed data
      setDataTypes(responseData?.data_types)
      setCategory(responseData?.columns)
      setRowValues(responseData?.null_values)
      setUniqueValue(responseData?.unique_values_count)
      setGetTableRow(responseData?.total_rows)
      setStatistics(responseData?.statistics)
      setLoading(false)
      setGraphLoading(false)
    } catch (error) {
      console.error(error, 'error')
      setLoading(false)
      setGraphLoading(false)
    } finally {
      setLoading(false) // Ensure loading is stopped in both success and error cases
      setGraphLoading(false)
    }
  }, [])

  const dropHandler = (id: any) => {
    setDropDown(id)
    setDropDownVisible(!dropDownVisible)
  }

  const selectHandler = (index: any) => {
    setSelectedValue(index)
  }
  console.log(statistics, 'statistics')

  const tableRow = useMemo(() => {
    if (!chartData?.length || !dataTypes) return null

    console.log(dataTypes)

    return (
      <tr style={{ background: 'white', zIndex: '99' }}>
        {Object.keys(dataTypes)?.map((key: any, index: number) => {
          if (key.includes('user_id') || key.includes('filename')) return null

          let cellContent = null

          const isNumeric = chartData?.find(
            (p: any) => p?.column === key && dataTypes[key] === 'Numeric'
          )

          const isDate = dataTypes[key] === 'Date'

          if (isNumeric) {
            cellContent = (
              <Values
                uniqueValue={uniqueValue}
                identifier={key}
                getTableRow={getTableRow}
                rowValues={rowValues}
                statistics={statistics}
              />
            )
          } else if (isDate) {
            cellContent = (
              <HorizontalBar
                chartData={chartData}
                uniqueValue={uniqueValue}
                identifier={key}
                getTableRow={getTableRow}
                rowValues={rowValues}
                statistics={statistics}
              />
            )
          } else {
            const top3 =
              chartData?.find((t: any) => t.column === key)?.top_10_values?.slice(0, 3) || []

            cellContent = (
              <>
                {top3.map((percentage: any, idx: number) => (
                  <BarChartt
                    key={uuidv4()}
                    percentage={percentage}
                    chartDATA={chartData}
                    number={index}
                    chartApi={chartApi}
                    analyzeApi={analyzeAPI}
                    rowValues={rowValues}
                    uniqueValue={uniqueValue}
                    getTableRow={getTableRow}
                    tableData={tableData}
                    dataType={dataTypes}
                    identifier={key}
                  />
                ))}
              </>
            )
          }

          return (
            <td
              key={uuidv4()}
              style={{
                border: '1px solid #BDC4D1',
                minWidth: '150px',
                gap: '10px',
                padding: '10px'
              }}
            >
              {cellContent}
            </td>
          )
        })}
      </tr>
    )
  }, [dataTypes, chartData, chartApi, analyzeAPI, rowValues, uniqueValue, getTableRow, tableData])

  const getColorByIndex = (ind: number) => {
    if (ind % 2 === 0) return '#FC8003'
    if (ind % 3 === 0) return '#0085FF'
    if (ind % 5 === 0) return '#7703FC'
    return 'white'
  }

  const getBackgroundByIndex = (ind: number) => {
    if (ind % 2 === 0) return '#FFF2E6'
    if (ind % 3 === 0) return '#E5F3FF'
    if (ind % 5 === 0) return '#F1E6FF'
    return '#a6a6a6'
  }

  return (
    <>
      <div style={{ overflowX: 'scroll', height: '100%', overflowY: 'hidden' }}>
        {!tableData?.length || graphLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            {/* <div className='content'></div>  */}
            <InfiniteScroll
              // className='content'
              dataLength={tableData?.length}
              next={fetchData}
              hasMore={tableData?.length < getTableRow}
              loader={<Loader />}
              endMessage={
                <p
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center',
                    position: 'fixed',
                    background: 'hsl(217.9, 80.3%, 37.8%)',
                    color: '#fff',
                    alignItems: 'center',
                    padding: '10px 0'
                  }}
                >
                  You have seen it all
                </p>
              }
              height={650}
              style={{
                width: '100%',
                textAlign: 'center',
                scrollbarColor: '#e0e0e0 transparent',
                scrollbarWidth: 'auto'
              }}
            >
              <table
                className='tab '
                style={{
                  marginBottom: '0px',
                  tableLayout: 'fixed',
                  borderSpacing: '10px',
                  borderCollapse: 'collapse'
                }}
              >
                <thead
                  style={{
                    overflow: 'scroll',
                    position: 'sticky',
                    top: '-2px',
                    zIndex: '99',
                    background: 'white'
                  }}
                  className='content'
                >
                  {tableData.length > 0 && (
                    <tr
                      style={{
                        background: '#FFF5EB',
                        position: 'sticky',
                        top: '-10px',
                        zIndex: '99',

                        boxShadow: 'inset 0 1px 0 #BDC4D1, inset 0 -1px 0 #BDC4D1'
                      }}
                    >
                      {/* No Problem */}
                      {Object?.keys(tableData[0]).map(
                        (key: any, int: number) =>
                          !key?.includes('user_id') &&
                          !key?.includes('filename') && (
                            <>
                              <th
                                key={uuidv4()}
                                style={{
                                  whiteSpace: 'nowrap',
                                  padding: '3px 5px',
                                  alignItems: 'center',
                                  zIndex: '99',
                                  // borderTop: '6px solid #009ef7',
                                  // borderRight: '1px solid #BDC4D1',
                                  // borderLeft: '1px solid #BDC4D1',
                                  border: '1px solid #BDC4D1',
                                  background: 'white'
                                }}
                              >
                                <p
                                  style={{
                                    display: 'flex',
                                    margin: '0',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                  }}
                                >
                                  <span
                                    style={{
                                      marginRight: '40px',
                                      fontSize: '15px',
                                      fontWeight: '500'
                                    }}
                                  >
                                    {key}
                                  </span>

                                  <p
                                    style={{
                                      display: 'flex',
                                      margin: '0',
                                      flexDirection: 'column'
                                    }}
                                  >
                                    <span>
                                      <i className='bi bi-chevron-up'></i>
                                    </span>
                                    <span>
                                      <i className='bi bi-chevron-down'></i>
                                    </span>
                                  </p>
                                </p>
                              </th>
                            </>
                          )
                        //  }
                      )}
                    </tr>
                  )}

                  <tr
                    style={{
                      background: 'white',
                      zIndex: '99',
                      boxShadow: 'inset 0 1px 0 #BDC4D1, inset 0 -1px 0 #BDC4D1'
                    }}
                  >
                    {
                      // Object.keys(dataTypes)?.length === Object.keys(tableData[0]).length &&
                      //   Object.keys(dataTypes).every((key) =>
                      //     Object.keys(tableData[0]).includes(key)
                      //   ) &&
                      Object?.keys(dataTypes || {}).map(
                        (el: any, ind: number) =>
                          !el?.includes('user_id') &&
                          !el?.includes('filename') && (
                            <td
                              key={uuidv4()}
                              style={{
                                padding: '10px',
                                border: '1px solid #BDC4D1',
                                position: 'relative'
                              }}
                            >
                              <p
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  margin: '0'
                                }}
                              >
                                <span
                                  style={{
                                    color: getColorByIndex(ind),
                                    background: getBackgroundByIndex(ind),
                                    borderRadius: '100px',
                                    padding: '4px 10px',
                                    fontSize: '12px',
                                    textAlign: 'center'
                                  }}
                                >
                                  {dataTypes[el]}
                                </span>

                                <span onClick={() => dropHandler(ind)}>
                                  <i className='bi bi-chevron-down'></i>
                                </span>
                              </p>
                              {dropDown === ind && (
                                <>
                                  {dropDownVisible && (
                                    <p
                                      style={{
                                        background: '#f2f2f2',
                                        color: 'black',
                                        width: '100%',
                                        position: 'absolute',
                                        left: '0',
                                        right: '0',
                                        zIndex: '999',
                                        top: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        boxShadow:
                                          'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px',
                                        margin: '0',
                                        borderLeft: '1px solid black',
                                        borderRight: '1px solid black',
                                        gap: '5px'
                                      }}
                                    >
                                      {selectArry?.map((curEl: any, index: number) => (
                                        <span
                                          key={uuidv4()}
                                          className='drop_span'
                                          style={{
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            fontSize: '12px',
                                            background:
                                              selectedValue === index ? '#ff4d4d' : '#f2f2f2',
                                            color: selectedValue === index ? 'white' : 'black'
                                          }}
                                          onClick={() => selectHandler(index)}
                                        >
                                          {curEl}
                                          {ind}
                                        </span>
                                      ))}
                                    </p>
                                  )}
                                </>
                              )}
                            </td>
                          )
                      )
                    }
                  </tr>

                  {tableRow}
                </thead>

                <tbody
                  style={{
                    overflow: 'scroll'
                  }}
                >
                  {tableData?.length &&
                    tableData?.map((el: any, int: number) => (
                      <tr key={uuidv4()}>
                        {Object?.keys(el)?.map((item: any, id: number) => (
                          // (!el.includes('user_id') && !el.includes('filename')) &&(
                          <>
                            {item !== 'user_id' && item !== 'filename' && (
                              <td
                                key={uuidv4()}
                                style={{
                                  border: '1px solid #BDC4D1',
                                  whiteSpace: 'nowrap',
                                  minWidth: '150px',
                                  padding: '10px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '200px'
                                }}
                              >
                                {el[item]}
                              </td>
                            )}
                          </>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </InfiniteScroll>
            {/* </HorizontalScrollingMenu> */}
          </>
        )}
      </div>
    </>
  )
}
// const MemoizedBarChartt = React.memo(BarChartt)

export default TableHeader
